module.exports = __webpack_public_path__ + "static/media/new-order-illustration.2550b2d8.svg";